import { z } from 'zod';
/** Digest demo-data slice — the Performance Digest inputs the reference dgModel() embeds
 *  (design-reference script lines 1767–1872): the reported balance KPI, the archive rows and the AI outlook paragraph.
 *  Every field is deterministic and labeled simulated; period KPIs, daily P&L and symbol breakdown derive from `trades()` at build time. */
export const DigestArchiveRowSchema = z
  .object({
    period: z.string(), // Weekly / Monthly
    range: z.string(), // display range, e.g. 'Jul 11 — Jul 17, 2026'
    pnl: z.string(), // display P&L, verbatim
    pnlFg: z.string(), // colour token
    trades: z.string(), // 'N trades'
    summary: z.string(),
  })
  .strict();
export const DigestDataSchema = z
  .object({
    /** Balance KPI tile value (display string). */
    balance: z.string(),
    /** The current (live) history row — its P&L and trade count are computed from the ledger at build time. */
    current: z.object({ period: z.string(), range: z.string(), summary: z.string() }).strict(),
    /** Archived digests listed after the current row. */
    archive: z.array(DigestArchiveRowSchema),
    /** Second AI-summary paragraph (the first is composed from the period numbers). */
    aiOutlook: z.string(),
  })
  .strict();
export type DigestData = z.infer<typeof DigestDataSchema>;
export type DigestArchiveRow = z.infer<typeof DigestArchiveRowSchema>;
